import { useState } from "react";

import Date from "../../../../Core/Fields/Floating/Date";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab4 = ({
  IdData,
  AllowPurchaseInvoiceCreationWithoutPurchaseOrder,
  IsFrozen,
  AllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
  Disabled,
  BlockSupplier,
  HoldType,
  ReleaseDate
}) => {
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>

        <div className="col-4">
          <div className="mb-2">
            <Checkbox
              id="AllowPurchaseInvoiceCreationWithoutPurchaseOrder"
              label="Allow Purchase Invoice Creation Without Purchase Order"
              value={
                AllowPurchaseInvoiceCreationWithoutPurchaseOrder?.AllowPurchaseInvoiceCreationWithoutPurchaseOrder ||
                false
              }
              onChange={(val) =>
                AllowPurchaseInvoiceCreationWithoutPurchaseOrder?.setAllowPurchaseInvoiceCreationWithoutPurchaseOrder?.(
                  val
                )
              }
            />
          </div>
        </div>

        <div className="col-6">
          <div className="mb-2">
            <Checkbox
              id="IsFrozen"
              label="Is Frozen"
              value={IsFrozen?.IsFrozen || false}
              onChange={(val) => IsFrozen?.setIsFrozen?.(val)}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-2">
            <Checkbox
              id="AllowPurchaseInvoiceCreationWithoutPurchaseReceipt"
              label="Allow Purchase Invoice Creation Without Purchase Receipt"
              value={
                AllowPurchaseInvoiceCreationWithoutPurchaseReceipt?.AllowPurchaseInvoiceCreationWithoutPurchaseReceipt ||
                false
              }
              onChange={(val) =>
                AllowPurchaseInvoiceCreationWithoutPurchaseReceipt?.setAllowPurchaseInvoiceCreationWithoutPurchaseReceipt?.(
                  val
                )
              }
            />
          </div>
        </div>

        <div className="col-6">
          <div className="mb-2">
            <Checkbox
              id="Disabled"
              label="Disabled"
              value={Disabled?.Disabled || false}
              onChange={(val) => Disabled?.setDisabled?.(val)}
            />
          </div>
        </div>
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Block Supplier</p>
        </div>

        <div className="col-12">
          <div className="mb-3">
            <Checkbox
              id="BlockSupplier"
              label="Block Supplier"
              value={BlockSupplier?.BlockSupplier || false}
              onChange={(val) => BlockSupplier?.setBlockSupplier?.(val)}
            />
          </div>
        </div>

        {BlockSupplier?.BlockSupplier && (
          <>
            <div className="col-6">
              <div className="mb-3">
                <SelectSearch
              list={[
                { name: "All" },
                { name: "Invoices" },
                { name: "Payments" },
              ]}
              style={{
                height: "30px",
                border: HoldType?.Error ? "1px solid red" : "",
              }}
              label="Hold Type"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={HoldType?.HoldType || ""}
              onChange={(value) => HoldType?.setHoldType?.(value)}
            />
              </div>
            </div>
            <div className="col-6">
              <div className="mb-2">
                <Input
                type="date"
                  id="ReleaseDate"
                  label="Release Date"
                  style={{
                    height: "30px",
                    border: ReleaseDate.Error ? "1px solid red" : "",
                  }}
                  value={ReleaseDate.ReleaseDate}
                  onChange={(e) => ReleaseDate.setReleaseDate(e.target.value)}
                />
              </div>
            </div>
          </>
        )}
      </div>
                     <div className="">
        <ActivityCard doctype="Supplier" docname={IdData} />
      </div>
       
    </>
  );
};

export default Tab4;
